import { useState } from "react";
import { useHistory } from "../../router/useHistory";

import I18n, { i18n } from "../../pages/private/languageSelector";
import Dialog from "./Dialog";
import SubscriptionCustomToast from "./SubscriptionCustomToast";

const PlanDialog = ({
  cancelSubscription,
  setShowDetailsDialog,
  StartFreeTrialHandler,
  onClose,
  modalTitle,
  text_one,
  text_two,
  primaryButtonLabel,
  secondaryButtonLabel,
  handleModalAction,
  setShowCardDialog,
  isInput,
  isPaymentCardAdded,
  setShowPricingPlanModal,
  actionType,
  saveButtonColor,
  saveButtonClasses,
  notShowCancelButton,
  isNotificationPopup = false,
}) => {
  const history = useHistory();
  const [inputValue, setInputValue] = useState("");
  const [inputError, setInputError] = useState(false);

  const showSaveButton = !!primaryButtonLabel;
  const showCancelButton = notShowCancelButton ? false : true;

  const handlePrimaryButtonClick = () => {
    if (actionType === "unsubscribeConfirm") {
      hanldeConfimrUnSubscription(inputValue);
    } else if (actionType === "open-notifications-form") {
      handleModalAction();
    } else if (actionType === "delete_user_device") {
      handleModalAction();
    } else if (actionType === "archive_other_report") {
      handleModalAction();
    } else if (actionType === "add_device_send_invite_link") {
      handleModalAction();
    } else if (actionType === "delete_site") {
      handleModalAction();
    } else if (actionType === "continue_subscription_to_add_payment_card") {
      handleModalAction();
    } else if (actionType === "delete_device") {
      handleModalAction();
    } else if (actionType === "close_update_plan") {
      handleModalAction();
    } else if (actionType === "archive_my_report") {
      handleModalAction();
    } else if (actionType === "delete_archive_report") {
      handleModalAction();
    } else if (actionType === "delete_share-history_of_report") {
      handleModalAction();
    } else if (actionType === "close_global_list_item_unsaved_changes") {
      handleModalAction();
    } else if (actionType === "cancel_trial-and_subscription_is_running") {
      cancelSubscription();
    } else if (actionType === "updatePaymentCard") {
      cancelSubscription();
    } else if (actionType === "subscriptionAfterCancelTrial") {
      handleModalAction();
    } else if (actionType === "start_form_inspection") {
      handleModalAction();
    } else if (actionType === "exist_form_inspection") {
      handleModalAction();
    } else if (actionType === "resumeSubscription") {
      cancelSubscription();
    } else if (primaryButtonLabel === i18n("Subscriptions.UPDATEPLAN")) {
      history.push("/management/subscriptions/update-plan");
    } else if (primaryButtonLabel === i18n("Subscriptions.Unsubscribe")) {
      hanldeConfimrUnSubscription(inputValue);
    } else if (primaryButtonLabel === i18n("Subscriptions.Submit")) {
      hanldeConfimrUnSubscription(inputValue);
    } else if (primaryButtonLabel === i18n("Subscriptions.Continue")) {
      handleModalAction();
    } else if (primaryButtonLabel === i18n("Subscriptions.CreateNewUser")) {
      history.push(`/management/users/add`);
      onClose();
    } else if (primaryButtonLabel === i18n("Subscriptions.CANCELTRIAL")) {
      cancelSubscription();
    } else if (primaryButtonLabel === i18n("Subscriptions.RevertToFreePlan")) {
      cancelSubscription();
    } else if (primaryButtonLabel === i18n("Subscriptions.Subscribe")) {
      hanldeUpdateSidebarShow();
      onClose();
    } else if (primaryButtonLabel === i18n("Subscriptions.AddPaymentMethod")) {
      setShowCardDialog(true);
      onClose();
    } else if (primaryButtonLabel === i18n("Subscriptions.ResumesSubscription")) {
      cancelSubscription();
    } else if (isPaymentCardAdded) {
      setShowCardDialog(false);
      onClose();
    } else if (primaryButtonLabel === i18n("Modals.CONTINUE")) {
      handleModalAction();
    } else if (primaryButtonLabel === i18n("Subscriptions.ENDTRIAL")) {
      cancelSubscription();
    } else if (primaryButtonLabel === i18n("Subscriptions.ConfirmForUnsubscribedModal")) {
      cancelSubscription();
    } else if (primaryButtonLabel === i18n("Modals.REVERTTOFREEPLAN")) {
      cancelSubscription();
    } else {
      StartFreeTrialHandler();
    }
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    setInputError(false);
  };

  const hanldeUpdateSidebarShow = () => {
    if (setShowDetailsDialog) {
      setShowDetailsDialog(true);
    }
    if (setShowPricingPlanModal) {
      setShowPricingPlanModal(true);
    }
    onClose();
  };

  const hanldeConfimrUnSubscription = (text) => {
    if (text === "Unsubscribe") {
      cancelSubscription();
      SubscriptionCustomToast(i18n("Modals.UnsubscribedSuccessfully"));
      onClose();
    } else {
      setInputError(true);
    }
  };

  return (
    <Dialog
      title={modalTitle}
      showCloseIcon={false}
      onClose={onClose}
      onSave={handlePrimaryButtonClick}
      onCancel={onClose}
      showCancelButton={showCancelButton}
      showSaveButton={showSaveButton}
      saveButtonTitle={primaryButtonLabel}
      cancelButtonTitle={secondaryButtonLabel}
      customClasses="w-[328px]"
      buttonAlignment="evenly"
      saveButtonColor={saveButtonColor}
      saveButtonClasses={saveButtonClasses}
      {...(isInput && {
        saveButtonColor: `text-${inputValue === "Unsubscribe" ? "colPrimary" : "colGrayLight"}`,
      })}
    >
      <div className="p-2 flex flex-col items-center">
        <p className={`text-center ${isNotificationPopup && "w-100"} text-sm font-normal text-gray-800`}>{text_one}</p>
        {text_two && <p className="text-center py-3 text-sm font-normal text-gray-800 max-w-xs">{text_two}</p>}
        {isInput && (
          <div className="w-full px-4 mt-3">
            <input type="text" className="form-input w-full border-gray-300 rounded-md" onChange={handleInputChange} />
          </div>
        )}
        {inputError && (
          <span className="text-red-500 text-sm mt-2 w-full px-4">
            <I18n lng="Subscriptions.PleaseTypeUnsubscribe" />
          </span>
        )}
      </div>
    </Dialog>
  );
};

export default PlanDialog;
